import { Component, OnInit , AfterViewInit } from '@angular/core';
import {DataService} from '../data.service';

declare var $:any;
declare var fbq:any;

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit,AfterViewInit {
  planId:number=-1;
  userTypeId:number=-1;
  constructor(private service:DataService) { }

  ngOnInit() {

    setTimeout(function(){
      // fbq('trackCustom','virtualPageView',{
      //   url:'https://www.stratgist.com/thanks'
      // })
      fbq('track', 'Purchase');
    },5000)


    localStorage.removeItem('isLoading');
    this.userTypeId=localStorage.getItem("UserTypeId")==null ? -1 : parseInt(localStorage.getItem("UserTypeId"));
    this.planId=localStorage.getItem("planId")==null ? -1 : parseInt(localStorage.getItem("planId"));
  }

  ngAfterViewInit(){

    $(window).scrollTop(0);
    $('.cd-header').removeClass('menu-is-open');
    $('.cd-header').css('background-color','rgb(147, 18, 70)');
    // $('.cd-header').css('backgroundColor', 'transparent');

    $('.cd-header').removeClass('is-fixed');
  }

}



// WEBPACK FOOTER //
// E:/Thakur/github/Stratgist-latest/Stratgist LandingPage/src/app/thank-you/thank-you.component.ts